let initialLoadTimeout: NodeJS.Timeout | null = null;

const personalFormMiddleware =
  (storeAPI: any) => (next: any) => (action: any) => {
    const result = next(action);

    if (
      !action.type.startsWith('autoPersonalForm/') &&
      !action.type.startsWith('homePersonalForm/')
    ) {
      return result;
    }

    // Do not mark the form as changed on certain actions
    const formPrefix = action.type.startsWith('autoPersonalForm/')
      ? 'autoPersonalForm'
      : 'homePersonalForm';

    if (
      [
        `${formPrefix}/changeIsDataSaved`,
        `${formPrefix}/setBinderPDF`,
        `${formPrefix}/setSigning`,
        `${formPrefix}/updatePayments`,
        `${formPrefix}/removeMissingMandatoryField`,
        `${formPrefix}/addMissingMandatoryField`,
        `${formPrefix}/updateWipStatus`,
      ].includes(action.type)
    ) {
      return result;
    }

    storeAPI.dispatch({
      type: `${formPrefix}/changeIsDataSaved`,
      payload: false,
    });

    // Reset to saved state after initial form load
    if (action.type === `${formPrefix}/storeData`) {
      if (initialLoadTimeout) {
        clearTimeout(initialLoadTimeout);
      }

      initialLoadTimeout = setTimeout(() => {
        storeAPI.dispatch({
          type: `${formPrefix}/changeIsDataSaved`,
          payload: true,
        });
      }, 1500);
    }

    return result;
  };

export default personalFormMiddleware;
